import Vue from "vue";
import notFoundMixin from "@/mixins/notFoundMixin";
export default Vue.extend({
    mixins: [notFoundMixin],
});
